/**
 * QuickArmPresets — localStorage helpers for the user's personal
 * multi-track arm/routing templates (saved from the Tracking Controls
 * Quick Arm row).
 *
 * Schema:
 *   {
 *     id:        "preset-<timestamp>-<rand>",
 *     name:      "My Podcast 3-mic Setup",
 *     createdAt: ISO8601,
 *     channels:  [0, 1, 2, ...]    // channel indices to arm
 *     sourceMap: { 0: 0, 1: 1, 2: 0 } // ch -> input source
 *   }
 *
 * iter-207 — User-saved preset row entries.
 */
const STORAGE_KEY = "elpm:quick-arm-custom-presets";
const MAX_PRESETS = 8;   // small cap; the Quick Arm row stays tidy

export function loadCustomPresets() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    void e;
    return [];
  }
}

export function saveCustomPreset(name, channels, sourceMap) {
  const all = loadCustomPresets();
  const entry = {
    id: `preset-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    name: String(name || "Untitled").slice(0, 40),
    createdAt: new Date().toISOString(),
    channels: Array.isArray(channels) ? Array.from(new Set(channels)).sort((a, b) => a - b) : [],
    sourceMap: { ...(sourceMap || {}) },
  };
  const next = [entry, ...all].slice(0, MAX_PRESETS);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (e) {
    void e;
  }
  return entry;
}

export function removeCustomPreset(id) {
  const all = loadCustomPresets();
  const next = all.filter((p) => p.id !== id);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (e) {
    void e;
  }
  return next;
}
